import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { WebpackTranslateLoader } from '@app/translate-loader';

import { SharedModule } from '@app/shared';
import { CoreModule } from '@app/core';

import { AppComponent } from '@app/core/ui-components';
import { AppRoutingModule } from "@app/app-routing.module";

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    SharedModule,
    AppRoutingModule,
    CoreModule,
    AkitaNgDevtools.forRoot(),
    AkitaNgRouterStoreModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: WebpackTranslateLoader
      }
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

